import { render } from "./Customers.vue?vue&type=template&id=6f995576&scoped=true&ts=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"

import "./Customers.vue?vue&type=style&index=0&id=6f995576&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f995576"]])

export default __exports__